<section class="banner-section">
  <img [src]="layoutMobileUrl" />
</section>
